module.exports = __webpack_public_path__ + "static/blog-post-1.1-6574888137838423dd87768a103e5800.png";